import { RequestState } from "common/RequestState";

export const mapToObject = (items, getKey, requestState = () => RequestState.Finished) => {
  return items.reduce(
    (result, item) => ({ ...result, [getKey(item)]: { ...item, _requestState: requestState(item) } }),
    {}
  );
};

export const mapToPages = (items, getKey, pageSize) => {
  const result = {};
  const pagesCount = items.length / pageSize;
  for (let i = 0; i < pagesCount; i++) {
    const start = i * pageSize;
    result[i + 1] = items.slice(start, start + pageSize).map(o => getKey(o));
  }
  return result;
};

export const mergePages = (state, pageSize, pageNumber, total, items) => {
  // remove saved pages if total or pageSize has changed
  if (!state || state.total !== total || state.pageSize !== pageSize) {
    return { [pageNumber]: items };
  }

  return { ...state.pages, [pageNumber]: items };
};

/** Merges a new page into redux state of paginated items */
export const mergeInNewPage = (state, pageSize, pageNumber, total, items, getKey) => {
  const pages = mergePages(state, pageSize, pageNumber, total, items.map(getKey));

  return { ...state, ...mapToObject(items, getKey), pageSize, total, pages, _requestState: RequestState.Finished };
};
